'use strict';

var BannerCarouselConfig = require('../../../utils/bannerCarouselConfig');

/**
 * Initialize the Image Stack Text Slider component with Slick carousel
 */
function initImageStackTextSlider() {
    var component = document.querySelector('.image-stack-text-slider');
    if (!component) {
        return;
    }

    var $component = $(component);
    var $carousel = $component.find('.carousel-slides');

    // Prevent duplicate initialization
    if ($carousel.hasClass('slick-initialized')) {
        return;
    }

    if (!$carousel.length) {
        return;
    }

    var totalSlides = $carousel.find('.carousel-slide').length;

    if (totalSlides <= 1) {
        return; // No need for carousel with single slide
    }

    // Read settings from data attributes
    var autoRotate = component.dataset.autoRotate === 'true';
    var rotateInterval = parseInt(component.dataset.rotateInterval, 10) || 5000;
    var pauseOnHover = component.dataset.pauseOnHover === 'true';
    var showArrows = component.dataset.showArrows !== 'false';

    // Find arrows - they're always rendered in template now (outside loop)
    var $prevArrow = $component.find('.carousel-arrow-prev');
    var $nextArrow = $component.find('.carousel-arrow-next');

    // Ensure arrows are found - they should always exist in template
    if (!$prevArrow.length || !$nextArrow.length) {
        // Don't proceed if arrows don't exist - Slick needs them for accessibility
        return;
    }

    // Hide arrows if disabled (but keep them in DOM for Slick accessibility)
    if (!showArrows) {
        $prevArrow.hide();
        $nextArrow.hide();
    }

    // Initialize Slick carousel with config from utility
    // Arrows always exist now, so always pass them
    var slickConfig = BannerCarouselConfig.getHeroBannerConfig({
        prevArrow: $prevArrow,
        nextArrow: $nextArrow,
        autoRotate: autoRotate,
        rotateInterval: rotateInterval,
        pauseOnHover: pauseOnHover
    });

    // Initialize Slick carousel (only if not already initialized)
    // No need for visibility/width checks - we're already called on DOM ready/window load
    if (!$carousel.hasClass('slick-initialized')) {
        try {
            $carousel.slick(slickConfig);
        } catch (e) {
            // Error initializing Slick carousel
        }
    }
}

// Initialize when DOM is ready
$(document).ready(function () {
    initImageStackTextSlider();
});
